<!--
 * @Author: Src
 * @Date: 2024-12-22 14:56:04
 * @LastEditTime: 2024-12-26 09:33:54
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/components/topTitle.vue
 * @Description: 顶部标题组件
-->
<template>
    <div class="top-title-container">
        <div class="top-title">
            <div class="top-title-left">
                <slot name="left"></slot>
        </div>
        <div class="top-title-center">
            <slot name="center"></slot>
        </div>
        <div class="top-title-right">
            <slot name="right"></slot>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { Vue } from 'vue-property-decorator';
export default class TopTitle extends Vue {}
</script>
<style lang="scss" scoped>
.top-title-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}
.top-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    background-color: #fff;
    height: 50px;
    border-bottom: 1px solid #e5e5e5;
}

.top-title-left {
    flex: 1;
}

.top-title-center {
    flex: 2;
    text-align: center;
    // font-size: 28px;
    font-weight: bold;
}

.top-title-right {
    flex: 1;
}
</style>
